export default "__VITE_ASSET__DUZuPx9f__"